import { Locales } from '@constants';

function getLocale() {
  const { host } = window.location;
  if (host in Locales) {
    return Locales[host as keyof typeof Locales];
  }
  return Locales.default;
}

export default getLocale;
